module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAgMAAADyVVYGAAAACVBMVEUAIJ/////0KkFPTYHQAAAAJ0lEQVR4AWOAANFQBIhaBQIrhr/MqMyozKjMqMyozKjMqMyozKgMAH2AHl51ftA1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/france.png
// module id = 626
// module chunks = 0